export const ICopyToClipboardUseCaseType = Symbol('ICopyToClipboardUseCase');
